import React from 'react';
import PropTypes from 'prop-types';

import useWidth from '../../Hooks/useWidth';
import MobileStepTabs from './MobileStepTabs';
import DesktopStepTabs from './DesktopStepTabs';

function StepTabs({ tabs = [], value, onChange = () => {} }: any) {
  const mobile = useWidth('down', 'sm');

  if (mobile) {
    return <MobileStepTabs tabs={tabs} onChange={onChange} value={value} />;
  }

  return <DesktopStepTabs tabs={tabs} onChange={onChange} value={value} />;
}

StepTabs.propTypes = {
  onChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      dates_status: PropTypes.string,
      stateLabel: PropTypes.string,
    }).isRequired,
  ),
  value: PropTypes.number.isRequired,
};

export default StepTabs;
